import { html } from "lit";

export default html`
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M11.993 4.621C9.874 2.6 6.633 2.14 4.141 4.269c-2.63 2.248-3.01 6.025-.933 8.697.81 1.044 2.41 2.63 3.968 4.1a175.563 175.563 0 0 0 3.908 3.566l.012.01c.076.067.157.14.233.197.088.066.202.139.35.183.204.06.425.06.629 0a1.1 1.1 0 0 0 .35-.183c.076-.058.157-.13.233-.197l.012-.01a176.27 176.27 0 0 0 3.909-3.566c1.557-1.47 3.156-3.056 3.968-4.1 2.07-2.664 1.746-6.47-.94-8.702-2.525-2.098-5.73-1.665-7.847.357Zm-.474 1.314C9.803 3.93 7.026 3.45 4.953 5.22c-2.129 1.819-2.42 4.84-.758 6.979.742.956 2.271 2.478 3.839 3.958a174.322 174.322 0 0 0 3.96 3.61l.08-.071a174.3 174.3 0 0 0 3.88-3.54c1.567-1.48 3.096-3.001 3.839-3.957 1.667-2.146 1.402-5.183-.752-6.974-2.12-1.762-4.862-1.29-6.572.71a.625.625 0 0 1-.95 0Z"
      clip-rule="evenodd"
    />
  </svg>
`;
